import React from 'react'
import { FormattedMessage } from 'react-intl'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import Pill from 'LuxKit/Pill'
import config from 'constants/config'

interface Props {
  testId?: string
  depositAmountPercentage?: number
}
function SecureWithDepositTag(props: Props) {
  const { testId, depositAmountPercentage } = props
  if (!config.DEPOSITS_TAGS_ENABLED) {
    return null
  }

  return (
    <Pill data-testid={testId} kind="tertiary" variant="primary" startIcon={<LineClockDollarIcon />}>
      <FormattedMessage
        id="kHYAUCPegs"
        defaultMessage="Secure with a {hasPercentage, select, true {{percentage}% } other {}}deposit"
        description="Tag label indicating the user can secure a booking with a deposit, optionally showing the deposit percentage"
        values={{
          hasPercentage: depositAmountPercentage ? 'true' : 'false',
          percentage: depositAmountPercentage,
        }}
      />
    </Pill>
  )
}
export default React.memo(SecureWithDepositTag)
